function downloadCSV (filename, header, data) {
  let content = []
  if (header) {
    content.push('"' + header.join('","') + '"')
  }
  for (let record of data) {
    content.push('"' + record.join('","') + '"')
  }

  content = content.join('\r\n')
  let bom = new Uint8Array([0xEF, 0xBB, 0xBF])
  let blob = new Blob([bom, content], { 'type': 'text/csv' })

  if (window.navigator.msSaveBlob) {
    window.navigator.msSaveBlob(blob, filename)
  } else {
    let a = document.createElement('a')
    a.download = filename
    // a.target = '_blank'
    a.href = window.URL.createObjectURL(blob)

    // firefox対策． chromeの場合は append/remove をしなくていいらしい
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }
}

export default downloadCSV



// WEBPACK FOOTER //
// ./src/misc/downloadCsv.js